import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'select2/dist/js/select2.min.js';
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>
);

// Only report web vitals in production, not in development
// This prevents performance issues in Chrome DevTools
if (process.env.NODE_ENV === 'production') {
  reportWebVitals();
}
